import { Group } from "../types/types";
import { get } from "../util/api";

/**
 * 全てのグループを取得
 */
export const findAllGroups = async (): Promise<Group[]> => {
  return await get<Group[]>("/groups");
};
